import React from "react";
import { Alert, AlertProps } from "@mui/material";

type CustomAlertProps = AlertProps & {
    label: string;
};

export default function CustomAlert(props: CustomAlertProps) {
    const { label, variant, severity, ...otherProps } = props;
    return (
        <Alert variant={variant} severity={severity} {...otherProps}>
            {props.label}
        </Alert>
    );
}
